import { render, staticRenderFns } from "./MakeCustomTaskComponent.vue?vue&type=template&id=bc7ccf02&scoped=true"
import script from "./MakeCustomTaskComponent.vue?vue&type=script&lang=js"
export * from "./MakeCustomTaskComponent.vue?vue&type=script&lang=js"
import style0 from "./MakeCustomTaskComponent.vue?vue&type=style&index=0&id=bc7ccf02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc7ccf02",
  null
  
)

export default component.exports